const S = /* @__PURE__ */ new Set(["top", "bottom", void 0, ""]), a = /* @__PURE__ */ new WeakSet(), c = /* @__PURE__ */ new WeakMap();
let b = !1;
const i = new CSSStyleSheet();
i.replaceSync(`
    .nav::-webkit-scrollbar {
        height: 6px;
    }
    .nav::-webkit-scrollbar-track {
        background: transparent;
    }
    .nav::-webkit-scrollbar-thumb {
        background-color: var(--wa-color-neutral-fill-loud);
        border-radius: 3px;
    }
`);
function w(e) {
  const t = e.shadowRoot;
  t && (t.adoptedStyleSheets.includes(i) || (t.adoptedStyleSheets = [...t.adoptedStyleSheets, i]));
}
function g() {
  if (b) return;
  b = !0, document.querySelectorAll("wa-tab-group").forEach(l), new MutationObserver((t) => {
    for (const o of t)
      o.type === "childList" && (o.addedNodes.forEach(y), o.removedNodes.forEach(A));
  }).observe(document.body, {
    childList: !0,
    subtree: !0
  });
}
function y(e) {
  var t;
  e instanceof HTMLElement && (e.tagName === "WA-TAB-GROUP" && l(e), (t = e.querySelectorAll) == null || t.call(e, "wa-tab-group").forEach(l));
}
function A(e) {
  var t;
  e instanceof HTMLElement && (e.tagName === "WA-TAB-GROUP" && d(e), (t = e.querySelectorAll) == null || t.call(e, "wa-tab-group").forEach(d));
}
function l(e) {
  if (a.has(e)) return;
  a.add(e);
  const t = e;
  (t.updateComplete ?? Promise.resolve()).then(() => {
    if (!a.has(e)) return;
    const r = t.nav;
    if (!r) return;
    w(e);
    const n = () => {
      if (!S.has(t.placement)) {
        e.removeAttribute("data-mxt-at-start"), e.removeAttribute("data-mxt-at-end");
        return;
      }
      const { scrollLeft: s, scrollWidth: f, clientWidth: m } = r, p = s <= 1, v = s + m >= f - 1;
      e.toggleAttribute("data-mxt-at-start", p), e.toggleAttribute("data-mxt-at-end", v);
    };
    r.addEventListener("scroll", n, { passive: !0 });
    const u = new ResizeObserver(n);
    u.observe(r), n(), c.set(e, () => {
      r.removeEventListener("scroll", n), u.disconnect(), r.style.removeProperty("scrollbar-width"), e.removeAttribute("data-mxt-at-start"), e.removeAttribute("data-mxt-at-end");
    });
  });
}
function d(e) {
  if (!a.has(e)) return;
  a.delete(e);
  const t = c.get(e);
  t && (t(), c.delete(e));
}
export {
  g as observeTabGroupScroll,
  d as unwireTabGroup,
  l as wireTabGroup
};
